module.exports = __webpack_public_path__ + "static/media/tiago_cristofer_aguzzoli_colombo.bf14f5e3.jpg";